import ElementHelpers from "./ElementHelpers"
import DataHelpers from "./DataHelpers"

export default class {

    static transferClientsFromTransaction(transactionKey) {
        ElementHelpers.fetchContactsForRole(transactionKey, 'Client').then(contacts => {
            const msRef = DataHelpers.getTenantRef().child('milestones').child(transactionKey)
            contacts.forEach(contact => {
                const contactRef = msRef.child('clients').child(contact.key)
                const newContact = {...contact}
                delete newContact.key
                delete newContact.role
                contactRef.set(newContact)
            })
        })
    }

    static transferBrokerAndProcessor(transactionKey) {
        const msRef = DataHelpers.getTenantRef().child('milestones').child(transactionKey)
        ElementHelpers.fetchContactsForRole(transactionKey, 'Broker').then(contacts => {
            if(contacts && contacts.length) {
                const brokerRef = msRef.child('broker')
                const broker = contacts[0]
                const newContact = {...broker}
                delete newContact.role
                brokerRef.set(newContact)
            }
        })
        ElementHelpers.fetchContactsForRole(transactionKey, 'Processor').then(contacts => {
            if(contacts && contacts.length) {
                const processorRef = msRef.child('processor')
                const processor = contacts[0]
                const newContact = {...processor}
                delete newContact.role
                processorRef.set(newContact)
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/helpers/MilestoneHelpers.js